import { Box, Modal } from '@mui/material';
import { AJOList, AJOState } from 'mp-js-react-auto-json-object';
import { Button } from 'flowbite-react';
import { Component } from 'react';
import { Spinner } from '../../commun/component/Spinner';
import { JSXInternal } from 'preact/src/jsx';
import { get } from '../../commun/HTTP';
import Result from '../../commun/Result';
import MpModal, { IBaseModalProps } from '../extends/MpModal';
import Product from 'src/object/tag/Product';
import { SelectProductList } from './SelectProductList';

export interface ISelectProductModalProps extends IBaseModalProps {
    selectList: Product[];
    onSelectList: (list: Product[]) => void;
}

export interface ISelectProductModalState {
    selectList: Product[];
    loading: boolean;
    list: AJOState<AJOList<Product>>;
}

export default class SelectProductModal extends Component<ISelectProductModalProps, ISelectProductModalState> {
    constructor(props: ISelectProductModalProps) {
        super(props);

        this.state = this.initState();
    }

    initState() {
        const p: ISelectProductModalState = {
            selectList: this.props.selectList,
            loading: false,
            list: new AJOState<AJOList<Product>>(new AJOList<Product>(Product)),
        };
        p.list.setUpdate((a) => {
            this.setState({
                list: a,
            });
        });
        if (this.props.open) {
            p.loading = true;
            get('/product_category/list', {}).then((res: any) => {
                this.setState({
                    loading: false,
                });
                if (Result.isSuccess(res)) {
                    Result.applyResult(res, this.state.list, true);
                }
            });
        }
        return p;
    }

    componentDidUpdate(
        prevProps: Readonly<ISelectProductModalProps>,
        prevState: Readonly<ISelectProductModalState>,
        snapshot?: any,
    ): void {
        if (prevProps.open !== this.props.open) {
            this.setState(this.initState());
        }
    }

    render(): JSXInternal.Element {
        const { open, onClose } = this.props;
        const { loading } = this.state;
        return (
            <MpModal
                open={open}
                onClose={onClose}
                onSubmit={() => {
                    this.props.onSelectList(this.state.selectList);
                    onClose();
                }}
                title="Sélectionner des offres"
                done="Sélectionner"
            >
                {loading ? (
                    <Box className="flex items-center justify-center py-12">
                        <Spinner color="blue" className="" />
                    </Box>
                ) : (
                    <SelectProductList
                        list={this.state.list.get()!.getList()}
                        selectList={this.state.selectList}
                        onSelectList={(list) => {
                            this.setState({
                                selectList: [...list],
                            });
                        }}
                    />
                )}
            </MpModal>
        );
    }
}
